import type { FindFn } from "@shared/models/analytics/base"
import type { Course } from "@shared/models/course"
import { get } from "lodash-es"

export default function (payload: { course: Course }, findFn: FindFn, userId: string) {
  let course = findFn("course", payload.course.id)
  let planbook = findFn("planbook", get(course, "relationships.planbook.data.id") as string)
  let user = findFn("user", userId)

  return {
    course,
    planbook,
    user,
  }
}
